import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";

import { Button } from "@hydra/atom/components";
import { BoxedContent, Header, NoDataFound } from "@/components/common";
import { FinanceMasterTable } from "@/components/finance";
import {
  getCurrencyRateTableColumns,
  getCurrencyRateTableData,
} from "@/components/finance/currency-rate/currencyRateTableData";
import { getCurrencyRates, deleteCurrencyRate } from "@/api/finance/currencyRateApi";
import { skeletonLoadingRows } from "@/utils/helpers";
import showToast from "@/utils/toast/helpers";

function CurrencyRate() {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery(["currency-rate"], getCurrencyRates);

  const queryClient = useQueryClient();
  const deleteMutation = useMutation(
    deleteCurrencyRate,
    {
      onError: () => {
        showToast("Could not delete. Try again!", "error");
      },
      onSuccess: () => {
        showToast("Deleted successfully", "success");

        queryClient.invalidateQueries({
          queryKey: ["currency-rate"]
        });
      },
    }
  );

  const renderTable = () => {
    if (!isLoading && data && !data?.data) {
      return (
        <NoDataFound
          title="No currency has been added"
          buttonText="Add currency"
          onClick={() => navigate("/finance/currency/new")}
        />
      );
    }
    return (
      <FinanceMasterTable
        objectName="CurrencyRate"
        isLoading={isLoading}
        tableColumns={getCurrencyRateTableColumns(data?.data || [])}
        data={getCurrencyRateTableData(data?.data || skeletonLoadingRows(5))}
        handleDelete={(id) => deleteMutation.mutate(id)}
      />
    );
  };

  return (
    <BoxedContent>
      <Header
        showBreadcrumb
        leftContent={<h1>Currency Rate</h1>}
        rightContent={(
          <Button small onClick={() => navigate("/finance/currency-rate/new")}>
            Add currency rate
          </Button>
        )}
      />

      {renderTable()}
    </BoxedContent>
  );
}

export default CurrencyRate;
